<script>
    import LabCard from "./LabCard.svelte";
</script>


<article class="bg-white border-slate-200 mt-6 px-4 lg:px-6 py-2.5">
    <div class="justify-between items-start mx-auto max-w-screen-xl">
        <h1 id="nav-labore" class="text-center mb-8">Online-Labore</h1>

        <LabCard
            bgColor='bg-onlabedu-blue'
            imgSrc='img/labs/kennlinien.jpg'
            title='Kennlinien-Labor'
            text='Unser Kennlinien-Labor ermöglicht es, das Verhältnis zwischen Strom und Spannung verschiedener elektronischer Bauteile zu messen und reale Messergebnisse in Echtzeit zu liefern. Die Messung wird als Graph aufgezeichnet und kann im Livestream beobachtet werden.'
        />

        <LabCard
            bgColor='bg-onlabedu-green'
            imgSrc='img/labs/spektrometrie.jpg'
            imgSide = 'right'
            title='Spektrometrie-Labor'
            text='Mit unserem Spektrometrie-Labor wird das Licht einer weißen LED in ihre sichtbaren Bestandteile (Spektrum) zerlegt und dargestellt. Zur Auswahl stehen diverse Farbfilter, die das Licht blockieren und somit das Spektrum verändern können. Der Livestream zeigt den Messvorgang und das Spektrum.'
            subText='Labor bald verfügbar!'
        />

        <LabCard
            bgColor='bg-onlabedu-red'
            imgSrc='img/labs/leslie.jpg'
            imgSide = 'l'
            title='Leslie-Würfel-Labor'
            text='Das Leslie-Würfel-Labor zeigt die Energieabgabe via Wärmebildkamera und unterstützt dies mit Messergebnissen. Es soll auf die unterschiedliche Abgabeintensität verschiedener Materialien und Oberflächen aufmerksam machen und die genauen Eckdaten verständlich machen.'
            subText='Labor bald verfügbar!'
        />

        <LabCard
            title='Weitere Labore ...'
            text='Im Rahmen des Projekts wird kontinuierlich an neuen Online-Laboren gearbeitet. Sie können auch jderzeit eigene Ideen und Konzepte für neue Online-Labore einbringen (Details siehe unten).'
        />

    </div>
</article>
